"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = require("../basicTypes/index");
exports.operation = [
    { name: "+", fn: function (leftTree, rightTree, ctx) {
            var left = leftTree ? leftTree.calculation(ctx) : new index_1.Atom("undefined", "unknow");
            var right = rightTree ? rightTree.calculation(ctx) : new index_1.Atom("undefined", "unknow");
            if (left.type === "string" || right.type === "string") {
                return new index_1.Atom("string", "unknow", left.toString() + right.toString());
            }
            else {
                return new index_1.Atom("number", "unknow", left.toNumber() + right.toNumber());
            }
        } },
    { name: "-", fn: function (leftTree, rightTree, ctx) {
            var left = leftTree ? leftTree.calculation(ctx) : new index_1.Atom("undefined", "unknow");
            var right = rightTree ? rightTree.calculation(ctx) : new index_1.Atom("undefined", "unknow");
            return new index_1.Atom("number", "unknow", left.toNumber() - right.toNumber());
        } },
    { name: "*", fn: function (leftTree, rightTree, ctx) {
            var left = leftTree ? leftTree.calculation(ctx) : new index_1.Atom("undefined", "unknow");
            var right = rightTree ? rightTree.calculation(ctx) : new index_1.Atom("undefined", "unknow");
            return new index_1.Atom("number", "unknow", left.toNumber() * right.toNumber());
        } },
    { name: "/", fn: function (leftTree, rightTree, ctx) {
            var left = leftTree ? leftTree.calculation(ctx) : new index_1.Atom("undefined", "unknow");
            var right = rightTree ? rightTree.calculation(ctx) : new index_1.Atom("undefined", "unknow");
            return new index_1.Atom("number", "unknow", left.toNumber() / right.toNumber());
        } },
    { name: "%", fn: function (leftTree, rightTree, ctx) {
            var left = leftTree ? leftTree.calculation(ctx) : new index_1.Atom("undefined", "unknow");
            var right = rightTree ? rightTree.calculation(ctx) : new index_1.Atom("undefined", "unknow");
            return new index_1.Atom("number", "unknow", left.toNumber() % right.toNumber());
        } },
    { name: ">", fn: function (leftTree, rightTree, ctx) {
            var left = leftTree ? leftTree.calculation(ctx) : new index_1.Atom("undefined", "unknow");
            var right = rightTree ? rightTree.calculation(ctx) : new index_1.Atom("undefined", "unknow");
            if (left.type !== "number" && right.type !== "number") {
                return new index_1.Atom("boolean", "unknow", left.toString() > right.toString());
            }
            else {
                return new index_1.Atom("boolean", "unknow", left.toNumber() + right.toNumber());
            }
        } },
    { name: "?", fn: function (leftTree, rightTree, ctx) {
            var _u = new index_1.Atom("undefined", "unknow");
            var left = leftTree ? leftTree.calculation(ctx) : _u;
            var right;
            if (left.toBoolean()) {
                right = rightTree ? rightTree.calculation(ctx) : new index_1.Atom("undefined", "unknow");
            }
            else {
                right = _u;
            }
            return new index_1.Atom("Array", "unknow", [left, right]);
        } },
    { name: ":", fn: function (leftTree, rightTree, ctx) {
            var left = leftTree ? leftTree.calculation(ctx) : new index_1.Atom("Array", "unknow");
            if (left.getChild(0).toBoolean()) {
                return left.getChild(1);
            }
            else {
                return rightTree ? rightTree.calculation(ctx) : new index_1.Atom("undefined", "unknow");
            }
        } },
    { name: "===", fn: function (leftTree, rightTree, ctx) {
            var left = leftTree ? leftTree.calculation(ctx) : new index_1.Atom("Array", "unknow");
            var right = rightTree ? rightTree.calculation(ctx) : new index_1.Atom("undefined", "unknow");
            return left.equal(right);
        } },
];
